import {
    SET_CATALOG_ITEM, 
    SET_CATALOG_SPECIFICATION_BY_SUBTYPE,
    SET_IS_CATALOG_ITEM_VALID_DELETE,
    SET_IS_VEHICLE_LEVEL_VALID_DELETE,
    SET_IS_EQ_CLASS_VALID_DELETE,
    SET_SAVE_MULTIPLE_CATALOG_STATUS
} from "./CatalogItemType";

const initialState = {
    catalogItem: {},
    catalogSpecificationList: [],
    isCatalogItemValidForDelete: null,
    isVehicleLevelValidForDelete: null,
    isEqClassValidForDelete: null,
    isSavedMultipleCatalogStatus: null
};

const reducer = (state :any = initialState, action: any) => {
    switch (action.type) {
        case SET_CATALOG_ITEM:
            return {
                ...state,
                catalogItem: action.catalogItem,
            };
        case SET_CATALOG_SPECIFICATION_BY_SUBTYPE:
            return {
                ...state,
                catalogSpecificationList: action.catalogItem,
            };
        case SET_IS_CATALOG_ITEM_VALID_DELETE:   
            return {
                ...state,
                isCatalogItemValidForDelete: action.isCatalogItemValidForDelete,
            };
        case SET_IS_VEHICLE_LEVEL_VALID_DELETE:
            return {
                ...state,
                isVehicleLevelValidForDelete: action.isVehicleLevelValidForDelete,
            };
        case SET_IS_EQ_CLASS_VALID_DELETE:
            return {
                ...state,
                isEqClassValidForDelete: action.isEqClassValidForDelete,
            };   
        case SET_SAVE_MULTIPLE_CATALOG_STATUS:
            return {
                ...state,
                isSavedMultipleCatalogStatus: action.isSavedMultipleCatalogStatus,
            };     
        default:
            return state;
    }
};

export default reducer;
